import { render, staticRenderFns } from "./BdTop.vue?vue&type=template&id=650e8728&scoped=true&"
import script from "./BdTop.vue?vue&type=script&lang=js&"
export * from "./BdTop.vue?vue&type=script&lang=js&"
import style0 from "./BdTop.vue?vue&type=style&index=0&id=650e8728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e8728",
  null
  
)

export default component.exports